import React from "react";
import {
  FaDiscord,
  FaRegArrowAltCircleRight,
  FaTelegram,
  FaTwitter,
} from "react-icons/fa";

import { RiTwitterXFill } from "react-icons/ri";

const socialList = [
  // {
  //   icon: <FaTelegram className=" text-primary" size={23} />,
  //   title: "Telegram Task",
  //   description:
  //     "Be the 1st to gain access to exclusive community updates, Every step we take on the development journey is being shared with our telegram community members 1st!",
  //   link: "/",
  // },
  {
  
    title: "Phase 1: Foundation and Launch Preparation",
    description:
      "Build a strong community, secure partnerships, launch the website, mint Angry Bears NFTs, and create a private Discord for holders.",

  },
  {

    title: "Phase 2: Ecosystem Expansion and Early Access",
    description:
      "Provide whitelist spots, early access to the DEX testnet, launch the Angry Bears token, airdrop rewards to Gen 1 holders, and prepare for BeraChain migration.",

  },
  {

    title: "Phase 3: Token Utility and Migration",
    description:
      "Expand token utility, complete the BeraChain migration, and introduce exclusive features for holders using the new infrastructure.",

  },
  {
  
    title: "Phase 4: Ecosystem Development and Growth",
    description:
      "Optimize the ecosystem post-migration, introduce governance voting, and expand partnerships with DeFi platforms and NFT marketplaces.",

  },
  {
   
    title: "Phase 5: Future Growth and Long-Term Expansion (TBA)",
    description:
      "Unveil future plans focusing on scaling the ecosystem, expanding utility, and exploring new integrations, with details to be announced later.",

  },
];

export default function TreeDisplay() {
  return (
    <div className="flex flex-col justify-center py-6 px-2">
      {socialList.map((item, idx) => (
        <div className=" px-2 flex  sm:grid md:grid-cols-[1fr,.3fr,1fr] grid-cols-[1fr,.2fr,1fr] sm:gap-2 gap-6 ">
          <div className="sm:hidden flex flex-col items-center">
            <div className="w-[1px] h-[6rem] bg-zinc-200" />
            <div className=" w-8 h-8 rounded-full border border-zinc-200 flex justify-center items-center">
              <div className=" h-3 w-3 rounded-full bg-zinc-200" />
            </div>
            <div className="w-[1px] h-[7rem] bg-zinc-200" />
          </div>

          {idx % 2 == 1 ? (
            <div className="flex flex-col gap-3 sm:items-end w-full sm:mb-0 mb-6 sm:text-right text-left">
              <h2 className=" font-semibold text-xl md:text-3xl">
                {item.title}
              </h2>

              <p className=" text-zinc-400 w-full sm:text-end text-start">
                {item.description}
              </p>
            </div>
          ) : (
            <div className=" sm:block hidden"></div>
          )}
          <div className="hidden sm:flex flex-col items-center ">
            <div className="w-[1px] h-[6rem] bg-zinc-200" />
            <div className=" w-8 h-8 rounded-full border border-zinc-200 flex justify-center items-center">
              <div className=" h-3 w-3 rounded-full bg-zinc-200" />
            </div>
            <div className="w-[1px] h-[7rem] bg-zinc-200" />
          </div>
          {idx % 2 == 0 ? (
            <div className="flex flex-col gap-3 sm:items-end w-full sm:mb-0 mb-6 text-left">
              <h2 className=" font-semibold text-xl md:text-3xl">
                {item.title}
              </h2>

              <p className=" text-zinc-400 w-full sm:text-left text-left">
                {item.description}
              </p>
            </div>
          ) : (
            <div className=" sm:block hidden"></div>
          )}
        </div>
      ))}
    </div>
  );
}
